"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerSelectInputAddon = TickerSelectInputAddon;
var _react = _interopRequireDefault(require("react"));
var _ui = require("../../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function TickerSelectInputAddon(props) {
  var options = props.options.map(function (o) {
    return {
      label: o,
      value: o
    };
  });
  return /*#__PURE__*/_react.default.createElement(_ui.SelectInputGroupAddon, {
    addonType: "append",
    selectProps: {
      defaultValue: options[0].value,
      value: props.value,
      options: options,
      onChange: function onChange(value) {
        var _props$onChange;
        return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, value);
      }
    }
  });
}